import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';

export default class Branch extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
            categories: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/branch/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });
        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/branch/save", {
            id: this.state.id,
            name: this.state.data.record.name,
            code: this.state.data.record.code,
            addStuffWebhook: this.state.data.record.addStuffWebhook,
            editStuffWebhook: this.state.data.record.editStuffWebhook,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شعبه" : "افزودن شعبه جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-9">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان:</label>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">کد:</label>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxLength="50" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}